/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_EyebrowInputs */

const en_us2_history_transfer_eyebrow = /** @type {(inputs: History_Transfer_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your data`)
};

const pt_br2_history_transfer_eyebrow = /** @type {(inputs: History_Transfer_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus dados`)
};

const es_419_history_transfer_eyebrow = /** @type {(inputs: History_Transfer_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus datos`)
};

const pt_pt2_history_transfer_eyebrow = /** @type {(inputs: History_Transfer_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os teus dados`)
};

const fr_fr2_history_transfer_eyebrow = /** @type {(inputs: History_Transfer_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes données`)
};

const de_de2_history_transfer_eyebrow = /** @type {(inputs: History_Transfer_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Daten`)
};

const it_it2_history_transfer_eyebrow = /** @type {(inputs: History_Transfer_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi dati`)
};

/**
* | output |
* | --- |
* | "Your data" |
*
* @param {History_Transfer_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_eyebrow = /** @type {((inputs?: History_Transfer_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_eyebrow(inputs)
	if (locale === "es-419") return es_419_history_transfer_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_eyebrow(inputs)
	return en_us2_history_transfer_eyebrow(inputs)
});
export { history_transfer_eyebrow as "history-transfer.eyebrow" }